import { useModelQuery } from "@/apollo/types";

export const useModel = (modelId: string) => {
  const { data, loading } = useModelQuery({
    variables: { modelId },
  });

  return { model: data?.model, loading };
};
